export default __webpack_public_path__ + "static/media/780.f10c192d.png";